import { orderBy } from 'lodash';
import env from '@/config/env';
import SliderPrincipalPlano from '@/graphql/tabela/queries/SliderPrincipalPlano.gql';

export const Types = {
  PLANOS: 'PLANOS',
  RESET: 'RESET',
};

export default {
  namespaced: true,
  state: {
    defaultPlanos: [1708, 1, 1678],
    planos: [],
  },
  getters: {
    planos: state => state.planos,
  },
  mutations: {
    [Types.PLANOS](state, payload) {
      state.planos.push({
        tabela: payload.tabela,
        celular: payload.celular,
        data: payload.data,
      });
    },
  },
  actions: {
    async getPlanos({ commit, state }, { tabela, celular, planos }) {
      try {
        const planos = planos || state.defaultPlanos
        const query = await env.tabela.query({
          query: SliderPrincipalPlano,
          variables: {
            tabela,
            modelo: celular,
            planos,
          },
          fetchPolicy: 'no-cache',
        });
        const { data } = query.data.planos;
        const order = orderBy(data, ['valor', 'foco'], ['asc', 'asc'])
        commit(Types.PLANOS, { tabela, celular, data: order });
        return order;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
